import { create } from 'zustand'

import type { QueryStore } from '@models/Query'

import { initialState } from '../services/fetchSubprocessen'
import type { FetchSubprocessen } from '../types/FetchSubprocessen'

export { useSubprocessenStore }

const useSubprocessenStore = () => {
  const query = useStore((state) => state.query)
  const storeQuery = useStore((state) => state.storeQuery)

  return { query, storeQuery }
}

const useStore = create<QueryStore<FetchSubprocessen['query']>>((set) => ({
  query: initialState.query,
  storeQuery: (query) =>
    set((state) => ({ query: { ...state.query, ...query } })),
}))
